import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  SEARCH_PRODUCT_REQUESTED,
  SEARCH_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_FAILURE,
  FIND_PRODUCT_INVENTORIES_REQUESTED,
  FIND_PRODUCT_INVENTORIES_SUCCESS,
  FIND_PRODUCT_INVENTORIES_FAILURE,
  DELETE_PRODUCT_METAFIELD_REQUESTED,
  DELETE_PRODUCT_METAFIELD_SUCCESS,
  UPDATE_SELECTED_ITEMS,
  SCAN_PRODUCT_REQUESTED,
  SCAN_PRODUCT_SUCCESS,
  SCAN_PRODUCT_FAILURE,
  RESET_PRODUCTS_STATE,
} from '../types';

export const searchProductsRequested = () => {
  return {
    type: SEARCH_PRODUCT_REQUESTED
  }
};

export const searchProductsSuccess = (products) => {
  return {
    type: SEARCH_PRODUCT_SUCCESS,
    payload: products
  }
};

export const searchProductsFailure = () => {
  return {
    type: SEARCH_PRODUCT_FAILURE
  }
};

export const inventoryDetailsRequested = () => {
  return {
    type: FIND_PRODUCT_INVENTORIES_REQUESTED
  }
}

export const inventoryDetailsSuccess = (payload) => {
  return {
    type: FIND_PRODUCT_INVENTORIES_SUCCESS,
    payload: payload
  }
}


export const productMetadataDeleteRequested = (productId, variantId, metafieldId) => {
  return {
    type: DELETE_PRODUCT_METAFIELD_REQUESTED,
    productId: productId,
    variantId: variantId,
    metafieldId: metafieldId,
  }
}

export const productMetadataDeleteSuccess = (payload) => {
  return {
    type: DELETE_PRODUCT_METAFIELD_SUCCESS,
    payload: payload
  }
}

export const setSelectedItems = (items) => {
  return {
    type: UPDATE_SELECTED_ITEMS,
    payload: items
  }
}

export const scanProductRequested = () => {
  return {
    type: SCAN_PRODUCT_REQUESTED
  }
};

export const scanProductSuccess = (product) => {
  return {
    type: SCAN_PRODUCT_SUCCESS,
    payload: product
  }
};

export const scanProductFailure = (message) => {
  return {
    type: SCAN_PRODUCT_FAILURE,
    message: message
  }
};

export const resetState = () => {
  return {
    type: RESET_PRODUCTS_STATE,
  }
}

export const searchProducts = (signedPayload, searchTerm, inStockFilter, purchasingDisabledFilter, categoryFilter, page) => {
  return (dispatch) => {
    dispatch(searchProductsRequested());

    let endPoint = Config.baseUrl + Config.productSearch;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      'term': searchTerm,
      'in_stock': inStockFilter,
      'disabled': purchasingDisabledFilter,
      'category': categoryFilter,
      'page': page
    }

    return Axios.post(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(searchProductsSuccess(response.data));
      });
  }
}

export const updateSelectedItems = (items) => {
  return (dispatch) => {
    dispatch(setSelectedItems(items));
  }
}

export const scanProduct = (signedPayload, scanTerm, supplierId) => {
  return (dispatch) => {
    dispatch(scanProductRequested());

    let endPoint = Config.baseUrl + Config.productScan;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      'barcode': scanTerm,
      'supplierId': supplierId,
    }

    return Axios.post(endPoint, body, { headers: headers })
      .then((response) => {
        let related_metadata = null;

        if((response.data.metafield_result === null) || response.data.metafield_result.data.length === 0) {
          return dispatch(scanProductFailure('No supplier assignments found for the scanned item.'));
        } else {
          related_metadata = response.data.metafield_result.data.find(assignment => assignment.key === `Supplier-${supplierId}` )
        }

        if(related_metadata === null) {
          return dispatch(scanProductFailure('No related supplier assignment found for the scanned item.'))
        }

        let item = {};

        if(response.data.scan_result.product_id) {
          item.productId = response.data.related_product_data.id;
          item.variantId = response.data.scan_result.id;
          item.productName = response.data.related_product_data.name;
          item.imageUrl = response.data.scan_result.image_url || response.data.related_product_data?.primary_image?.url_tiny;
          item.fullImageUrl = response.data.scan_result.full_image_url || response.data.related_product_data?.primary_image?.url_standard;
          item.options = response.data.scan_result.option_values;
          item.sku = response.data.scan_result.sku;
          item.upc = response.data.scan_result.upc;
          item.supplier_sku = JSON.parse(response.data.metafield_result.data[0].value).supplier_sku;
          item.supplier_price = JSON.parse(response.data.metafield_result.data[0].value).supplier_price;
          item.minimumOrder = JSON.parse(response.data.metafield_result.data[0].value).minimum_order;
        } else {
          item.productId = response.data.scan_result.id;
          item.variantId = null;
          item.productName = response.data.scan_result.name;
          item.imageUrl = response.data.scan_result?.primary_image?.url_tiny;
          item.fullImageUrl = response.data.scan_result?.primary_image?.url_standard;
          item.options = null;
          item.sku = response.data.scan_result.sku;
          item.upc = response.data.scan_result.upc;
          item.supplier_sku = JSON.parse(response.data.metafield_result.data[0].value).supplier_sku;
          item.supplier_price = JSON.parse(response.data.metafield_result.data[0].value).supplier_price;
          item.minimumOrder = JSON.parse(response.data.metafield_result.data[0].value).minimum_order;
        }

        dispatch(scanProductSuccess(item));
      });

  }
}

export const inventoryDetails = (signedPayload, productId, variantId) => {
  return (dispatch) => {
    dispatch(inventoryDetailsRequested(`${productId}/${variantId}`));

    let endPoint = Config.baseUrl + Config.product + Config.inventory + `?product_id=${productId}`;

    if(variantId) {
      endPoint = endPoint + `&variant_id=${variantId}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(inventoryDetailsSuccess(response.data));
      })
  }
}

export const deleteMetadata = (signedPayload, productId, variantId, metafieldId) => {
  return (dispatch) => {
    dispatch(productMetadataDeleteRequested(productId, variantId, metafieldId));

    let endPoint = Config.baseUrl + Config.product + Config.metafield + `?metafield_id=${metafieldId}&product_id=${productId}`;

    if(variantId) {
      endPoint = endPoint + `&variant_id=${variantId}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(productMetadataDeleteSuccess(response));
      })
  }
}

export const resetProducts = () => {
  return (dispatch)  =>{
    dispatch(resetState());
  }
}